import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import apiClient from '../../services/api';
import '../../css/VerifyEmail.css';
import { useTranslation } from 'react-i18next';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation(['auth']);
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState(t('auth:verify.verifying'));
  const [isVerifying, setIsVerifying] = useState(false); // 防止重复调用
  const hasVerified = useRef(false); // 使用 ref 来跟踪是否已经验证过

  useEffect(() => {
    const token = searchParams.get('token');
    
    console.log('🔍 前端验证页面 - 获取到的令牌:', token ? token.substring(0, 16) + '...' : 'null');
    console.log('🔍 完整的URL参数:', Object.fromEntries(searchParams.entries()));
    console.log('🔍 当前验证状态:', { status, isVerifying, hasVerified: hasVerified.current });
    
    if (!token) {
      setStatus('error');
      setMessage(t('auth:verify.invalid_link'));
      return;
    }

    // 防止重复调用 (React StrictMode 在开发环境下会调用两次 useEffect)
    if (isVerifying || status === 'success' || status === 'error' || hasVerified.current) {
      console.log('🔍 跳过重复调用，当前状态:', { isVerifying, status, hasVerified: hasVerified.current });
      return;
    }

    const verifyEmail = async () => {
      setIsVerifying(true);
      hasVerified.current = true; // 标记已经开始验证
      console.log('🔍 开始验证流程，设置 isVerifying = true, hasVerified = true');
      
      try {
        console.log('🔍 开始调用验证API...');
        const response = await apiClient.get(`/auth/verify-email?token=${token}`);
        
        console.log('✅ 验证API调用成功:', response.data);
        
        // if (response.data.token) {
        //   // 保存token到localStorage，使用与auth store相同的格式
        //   const authData = {
        //     user: response.data.user,
        //     token: response.data.token,
        //     isAuthenticated: true,
        //     lastLoginCredentials: {
        //       email: response.data.user.email,
        //       rememberEmail: false
        //     }
        //   };
        //   localStorage.setItem('auth-storage', JSON.stringify({ state: authData }));
          
        //   console.log('✅ 认证数据已保存到localStorage');
        // }
          
        setStatus('success');
        setMessage(t('auth:verify.success_desc_redirect'));
        
        // 3秒后跳转到主页
        setTimeout(() => {
          navigate('/');
        }, 3000);

      } catch (error) {
        console.error('❌ 邮箱验证失败:', error);
        console.error('错误响应:', error.response?.data);
        console.error('错误状态:', error.response?.status);
        setStatus('error');
        setMessage(error.response?.data?.message || t('auth:verify.invalid_link'));
      } finally {
        setIsVerifying(false);
        console.log('🔍 验证流程结束，设置 isVerifying = false');
      }
    };

    verifyEmail();
  }, [searchParams]); // 移除 navigate 依赖，只依赖 searchParams

  const handleResendEmail = async () => {
    // 这里可以添加重新发送验证邮件的功能
    // 需要用户输入邮箱地址
    navigate('/login?message=Please re-register or contact the administrator');
  };

  return (
    <div className="verify-email-container">
      <div className="verify-email-card">
        <div className="verify-email-header">
          <h1>{t('auth:verify.title')}</h1>
        </div>
        
        <div className="verify-email-content">
          {status === 'verifying' && (
            <div className="verifying-state">
              <div className="loading-spinner"></div>
              <p>{message}</p>
            </div>
          )}
          
          {status === 'success' && (
            <div className="success-state">
              <div className="success-icon">✓</div>
              <h2>{t('auth:verify.success_title')}</h2>
              <p>{message}</p>
            </div>
          )}
          
          {status === 'error' && (
            <div className="error-state">
              <div className="error-icon">✗</div>
              <h2>{t('auth:verify.fail_title')}</h2>
              <p>{message}</p>
              <button 
                className="resend-button"
                onClick={handleResendEmail}
              >
                {t('auth:verify.resend')}
              </button>
              <button 
                className="login-button"
                onClick={() => navigate('/login')}
              >
                {t('auth:verify.back_login')}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail; 